import { render, staticRenderFns } from "./ChatIcon.vue?vue&type=template&id=27eeedff&scoped=true"
import script from "./ChatIcon.vue?vue&type=script&lang=ts"
export * from "./ChatIcon.vue?vue&type=script&lang=ts"
import style0 from "./ChatIcon.vue?vue&type=style&index=0&id=27eeedff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eeedff",
  null
  
)

export default component.exports